import { createSlice, createAsyncThunk, PayloadAction } from "@reduxjs/toolkit";
import { Item } from "../../types/items";
import { collection, getDocs, addDoc, doc, deleteDoc, updateDoc } from "firebase/firestore";
import { db } from "../../firebase";

const ITEMS_COLLECTION = 'items';

const initialState: Item[] = [];

export const fetchItems = createAsyncThunk(
    "items/fetchItems",
    async () => {
        const items = await getDocs(collection(db, ITEMS_COLLECTION))
            .then((querySnapshot) => {
                return querySnapshot.docs
                    .map((doc) => ({ ...doc.data(), id: doc.id }));
            })

        return items as Item[];
    }
);

export const addItem = createAsyncThunk(
    "items/addItem",
    async (item: Omit<Item, 'id'>) => {
        alert('deprecated')
    }
);

export const deleteItem = createAsyncThunk(
    "items/deleteItem",
    async (id: Item['id']) => {
        const docRef = doc(db, ITEMS_COLLECTION, id);
        await deleteDoc(docRef);
        return id;
    }
);

export const updateItem = createAsyncThunk(
    "items/updateItem",
    async (item: Item) => {
        const docRef = doc(db, ITEMS_COLLECTION, item.id);
        await updateDoc(docRef, { ...item });
        return item;
    }
);

const itemsSlice = createSlice({
    name: "items",
    initialState,
    reducers: {
        setItems: (_state, action) => {
            return action.payload;
        },
        setItem: (state, action: PayloadAction<Item>) => {
            const _state = [...state];
            const index = _state.findIndex((item) => item.id === action.payload.id);
            _state.splice(index, 1, action.payload);
            return _state;
        }
    },
    extraReducers: (builder) => {
        builder.addCase(fetchItems.fulfilled, (_, action) => {
            return action.payload;
        });
        builder.addCase(addItem.fulfilled, (state, action) => {
            if (action.payload) {
                return state.concat([action.payload]);
            }
            return state;
        });
        builder.addCase(deleteItem.fulfilled, (state, action) => {
            if (action.payload) {
                return state.filter(({ id }) => id !== action.payload);
            }
            return state;
        });
        builder.addCase(updateItem.fulfilled, (state, action) => {
            if (action.payload) {
                const index = state.findIndex((category) => category.id === action.payload.id);
                state.splice(index, 1, action.payload);
            }
            return state;
        });
    }
});

export const { setItems, setItem } = itemsSlice.actions;

export default itemsSlice.reducer;
